var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'app--development': _vm.isDevelopment },attrs:{"id":"app"}},[_c('div',{staticClass:"layout--main",class:{
			'inside': _vm.hasPermission
		}},[(_vm.hasPermission)?_c('Header'):_vm._e(),_c('main',{class:{
				'development': _vm.isDevelopment,
				'router-view': _vm.hasPermission
			},attrs:{"id":"main"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }